export default "__VITE_ASSET__BjKpJLZW__"